module.exports = __webpack_public_path__ + "static/media/top-nerds.0defeb26.png";